import React, { useState } from "react";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import "./swiperStyle.scss";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import ShowSpeaker from "../../../Profile/ShowSpeaker";
import { Container, Row, Col } from "reactstrap";
import "./swiperStyle.scss";
import Divider from "./Divider";

const SpeakerCard = ({ title, name, role, description, image, speaker }) => {
  const [isToggleView, setIsToggleView] = useState(false);
  const [speakerDetails, setSpeakerDetails] = useState(null);

  // ✅ Safe defaults for all props
  const safeDescription = description || '';
  const safeName = name || 'Unknown';
  const safeTitle = title || '';
  const safeRole = role || '';
  const safeImage = image || '/images/default-avatar.png';

  const handleViewSpeaker = (details) => {
    setSpeakerDetails(details);
    setIsToggleView(!isToggleView);
  };

  const tog_Speaker = () => {
    setSpeakerDetails({});
    setIsToggleView(!isToggleView);
  };

  return (
    <div className="speaker-card-container h-100">
      <div className="speaker-card">
        <div className="speaker-image-wrapper">
          <img 
            src={safeImage} 
            alt={`${safeName} ${safeTitle}`} 
            className="speaker-image"
            onError={(e) => {
              e.target.src = '/images/default-avatar.png';
            }}
          />
          <div className="speaker-image-overlay" />
        </div>
        <div className="speaker-content p-2">
          <div className="speaker-name-title mb-1">
            {safeTitle && <span className="speaker-title">{safeTitle} </span>}
            <span className="speaker-name">{safeName}</span>
          </div>
          <div className="speaker-role mb-1">{safeRole}</div>
          <div className="speaker-description">
            {/* ✅ Fixed: Safe substring with null check */}
            {safeDescription.length <= 60 ? (
              <span>{safeDescription}</span>
            ) : (
              <>
                <span>{`${safeDescription.substring(0, 60)}...`}</span>
                <span
                  className="more-link"
                  onClick={() => handleViewSpeaker(speaker)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && handleViewSpeaker(speaker)}
                >
                  More
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="Speaker"
        body={<ShowSpeaker speaker={speakerDetails} showContacts={false} />}
        toggleSaveChanges={() => tog_Speaker()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />
    </div>
  );
};

const Speakers = ({ token, eventID }) => {
  const {
    data: getMySpeakers,
    error: errorGetMySpeakers,
    isLoading: isLoadingGetMySpeakers,
  } = useCustomFecthQuery(
    ["mySpeakers", eventID],
    `${process.env.REACT_APP_API}speakers/event/${eventID}`,
    token,
    { enabled: !!eventID }
  );

  if (getMySpeakers?.status === "ok" && getMySpeakers?.data?.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Container fluid className="px-3 px-md-4 px-lg-5">
        <Row className="justify-content-center">
          <Col xs={12}>
            <h1
              id="speakers"
              className="speakers-title text-center mb-3"
            >
              Our Speakers
              <span className="title-underline" aria-hidden="true" />
            </h1>
            <p className="speakers-subtitle text-center">
              Meet the experts shaping the future
            </p>
            <div className="d-flex justify-content-center mb-4 mb-md-5">
              <Divider />
            </div>
          </Col>
        </Row>
        
        <Row className="justify-content-center">
          <Col xs={12} lg={11} xl={10}>
            <div className="speakers-wrapper">
              <Swiper
                spaceBetween={24}
                centeredSlides={false}
                loop={true}
                autoHeight={true}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                  },
                  480: {
                    slidesPerView: 1.2,
                    spaceBetween: 18,
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1280: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                  },
                }}
                modules={[Autoplay, Pagination]}
                className="speakers-swiper"
              >
                {getMySpeakers?.data?.map((speaker, index) => (
                  <SwiperSlide key={speaker._id || index}>
                    <SpeakerCard
                      title={speaker.title}
                      name={speaker.firstName}
                      role={speaker.jobTitle}
                      description={speaker.speakerBiography}
                      image={speaker.photo}
                      speaker={speaker}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>

    </React.Fragment>
  );
};

export default Speakers;